import type { Locale } from './config';

/**
 * Per-locale metadata: the URL slug (the Locale key itself) intentionally
 * diverges from SEO codes. Haitian Creole uses the slug `creole` for
 * URL-readability, while hreflang/Intl/OG codes use the ISO `ht`/`ht_HT`.
 */
export const localeMeta: Record<Locale, {
  nativeName: string;
  englishName: string;
  hreflang: string;
  ogLocale: string;
  intl: string;
  ogImageAlt: string;
}> = {
  en: {
    nativeName: 'English',
    englishName: 'English',
    hreflang: 'en-CA',
    ogLocale: 'en_CA',
    intl: 'en-CA',
    ogImageAlt: 'Youth Alive Fellowship Canada - Many Branches Nationwide',
  },
  fr: {
    nativeName: 'Français',
    englishName: 'French',
    hreflang: 'fr-CA',
    ogLocale: 'fr_CA',
    intl: 'fr-CA',
    ogImageAlt: 'Jeunesse Vivante Canada - Plusieurs Branches au Canada',
  },
  es: {
    nativeName: 'Español',
    englishName: 'Spanish',
    hreflang: 'es',
    ogLocale: 'es_ES',
    intl: 'es-ES',
    ogImageAlt: 'Youth Alive Fellowship Canada - Múltiples sedes en todo el país',
  },
  creole: {
    nativeName: 'Kreyòl',
    englishName: 'Haitian Creole',
    hreflang: 'ht',
    ogLocale: 'ht_HT',
    intl: 'ht-HT',
    ogImageAlt: 'Youth Alive Fellowship Canada - Plizyè branch atravè peyi a',
  },
};

/** Order used by the language switcher dropdown. */
export const displayLocales: Locale[] = ['en', 'fr', 'es', 'creole'];
